import Box2D from 'box2dweb'
import EventsService from '../../helpers/eventsService'
import { CHARACTER_EVENTS } from './Events';

interface b2ContactManager {
  GetFixtureA:() => any,
  GetFixtureB: () => any,
}

export const EventsManager = new EventsService()

class Collisions {
  service: any
  constructor() {
    this.service = EventsManager
  }
  
  onAnyCollide(callback: Function) {
    this.onBeginContact(callback)
  }
  onCollide(callback: Function, filterUUID: string): Function {
    const filterCallback = (contact: b2ContactManager)  => {
      const fixtureA = contact.GetFixtureA()
      const fixtureB = contact.GetFixtureB()
      const uuidA = fixtureA.GetBody().GetUserData().uuid
      const uuidB = fixtureB.GetBody().GetUserData().uuid
      const isRelevantCollistion = [uuidA, uuidB].includes(filterUUID)
      const collideAgainstFixture = fixtureA.GetBody().GetUserData().uuid === filterUUID ? fixtureB : fixtureA
      if (isRelevantCollistion) {
        callback(collideAgainstFixture, contact)
      }
    }
    return this.onBeginContact(filterCallback)
  }

  onBeginContact(callback: Function): Function {
    return this.service.addEventListener(CHARACTER_EVENTS.BEGIN_CONTACT, callback)
  }

  onEndContact(callback: Function): Function {
    return this.service.addEventListener(CHARACTER_EVENTS.END_CONTACT, callback)
  }

  dispatchOnBeginContact(contact: b2ContactManager) {
    this.service.dispatch(CHARACTER_EVENTS.BEGIN_CONTACT, contact)
  }

  dispatchOnEndContact(contact: b2ContactManager) {
    this.service.dispatch(CHARACTER_EVENTS.END_CONTACT, contact)
  }
}

// class EventsManager {
//   service: any
//   constructor() {
//     this.service = new EventsService()
//   }
// }

export const CollisionsManager = new Collisions()
